export default __webpack_public_path__ + "static/media/get-huawei.9fc16c2e.svg";